import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './Ticket.css'; // Import the stylesheet
import JobManagement from './JobManagement'; // Renders the ticket list

function JobDetailsPage() {
  const { jobRunId } = useParams();
  const [jobDetails, setJobDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const staticJobId = 'run-aa2993f9-273a-4a35-b42b-7af4021d5dab';
    const controller = new AbortController();

    const fetchJobDetails = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/api/v2/jobs/run/${staticJobId}`, {
          signal: controller.signal,
        });
        setJobDetails(response.data);
        setIsLoading(false);
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log('Request canceled by cleanup');
        } else {
          setError('Failed to fetch job details.');
          setIsLoading(false);
        }
      }
    };

    fetchJobDetails();

    return () => {
      controller.abort();
    };
  }, []); // Empty array to run only once

  return (
    <div className="container">
      <JobManagement />

      {isLoading && <div className="section">Loading Ticket Details...</div>}
      {error && <div className="section" style={{ color: 'red' }}>{error}</div>}
      
      {jobDetails && (
        <div className="section ticket-details">
          <h2>{`Ticket #${jobDetails.jobRunId.substring(4, 10)} - ${jobDetails.jobTitle}`}</h2>
          
          <div className="meta">
            <div>Status: <span className={`badge status-${jobDetails.status.toLowerCase()}`}>{jobDetails.status}</span> | Job Name: <span>{jobDetails.jobName}</span></div>
            <div>Created: <span>{new Date(jobDetails.startTime).toLocaleDateString()}</span></div>
          </div>
          
          <p className="description">{jobDetails.jobDescription}</p>
          
          <div className="comments">
            <h3>Tasks</h3>
            {jobDetails.tasks.map((task, taskIdx) => (
              <div key={task.taskName + taskIdx} className="comment">
                <strong>{`${task.taskName} (Status: ${task.status})`}</strong>
                <p style={{margin: '5px 0 0 0'}}>{task.taskDescription}</p>
                
                {task.comments && task.comments.length > 0 && task.comments[0].text && (
                  <div style={{ marginLeft: '20px', marginTop: '10px', fontSize: '0.9em', borderTop: '1px solid #ddd', paddingTop: '10px' }}>
                    <strong>Comments:</strong>
                    {task.comments.map((comment, commentIdx) => (
                      <div key={comment.timestamp + commentIdx} style={{marginTop: '5px'}}>
                        {'• '} {comment.text} 
                        {comment.userId && <em>{` (by ${comment.userId})`}</em>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default JobDetailsPage;
